// @flow
import {
    ASSET_LIST,
    ASSET_LIST_SUCCESS,
    ASSET_LIST_FAILED,
    ASSET_ADD,
    ASSET_ADD_SUCCESS,
    ASSET_ADD_FAILED,
    ASSET_UPDATE,
    ASSET_UPDATE_SUCCESS,
    ASSET_UPDATE_FAILED,
    ASSET_DELETE,
    ASSET_DELETE_SUCCESS,
    ASSET_DELETE_FAILED
} from './constants';

type AssetAction = { type: string, payload: {} | string };

export const getAssetList = (data:{}): AssetAction => ({
    type: ASSET_LIST,
    payload: data,
});

export const getAssetListSuccess = (asset: string): AssetAction => ({
    type: ASSET_LIST_SUCCESS,
    payload: asset,
});

export const getAssetListFailed = (error: string): AssetAction => ({
    type: ASSET_LIST_FAILED,
    payload: error,
});

export const getAssetAdd = (data:{}): AssetAction => ({
    type: ASSET_ADD,
    payload: data,
});

export const getAssetAddSuccess = (assetAdd: string): AssetAction => ({
    type: ASSET_ADD_SUCCESS,
    payload: assetAdd,
});

export const getAssetAddFailed = (error: string): AssetAction => ({
    type: ASSET_ADD_FAILED,
    payload: error,
});

export const getAssetUpdate = (data:{}): AssetAction => ({
    type: ASSET_UPDATE,
    payload: data,
});

export const getAssetUpdateSuccess = (assetUpdate: string): AssetAction => ({
    type: ASSET_UPDATE_SUCCESS,
    payload: assetUpdate,
});

export const getAssetUpdateFailed = (error: string): AssetAction => ({
    type: ASSET_UPDATE_FAILED,
    payload: error,
});

export const getAssetDelete = (id): AssetAction => ({
    type: ASSET_DELETE,
    payload: id,
});

export const getAssetDeleteSuccess = (assetDelete: string): AssetAction => ({
    type: ASSET_DELETE_SUCCESS,
    payload: assetDelete,
});

export const getAssetDeleteFailed = (error: string): AssetAction => ({
    type: ASSET_DELETE_FAILED,
    payload: error,
});

